import React from 'react'
import { connect } from "react-redux";

// Multi-assign users as toggle chips. (Previously a native multiple <select>
// that required ctrl-click — most users only ever managed to pick one.)
class UsersComponent extends React.Component {

    toggleUser = (user) => {
        if (this.props.viewOnly || this.props.view) return;
        const selected = Array.isArray(this.props.lineItems) ? [...this.props.lineItems] : [];
        const idx = selected.findIndex(o => o.userId == user.userId);
        if (idx >= 0) selected.splice(idx, 1);
        else selected.push(user);
        this.props.updateLineItems(this.props.prop, selected);
    };

    render() {
        const users = (this.props.users || []).filter(u => !u.disabled);
        const selected = Array.isArray(this.props.lineItems) ? this.props.lineItems : [];
        const readOnly = this.props.viewOnly || this.props.view;

        return (
            <div style={{ margin: '10px 0' }}>
                <div style={{ fontSize: 12.5, fontWeight: 600, color: 'var(--text-secondary, #5a6b7b)', marginBottom: 6 }}>{this.props.header}</div>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 7 }}>
                    {users.map(u => {
                        const on = !!selected.find(o => o.userId == u.userId);
                        return (
                            <button
                                key={u.userId}
                                type="button"
                                onClick={() => this.toggleUser(u)}
                                disabled={readOnly}
                                style={{
                                    display: 'inline-flex', alignItems: 'center', gap: 6,
                                    padding: '6px 13px', borderRadius: 999,
                                    fontSize: 12.5, fontWeight: 600,
                                    cursor: readOnly ? 'default' : 'pointer',
                                    background: on ? 'linear-gradient(135deg, var(--primary, #0DA1B2), var(--primary-dark, #067886))' : 'rgba(255,255,255,0.65)',
                                    color: on ? '#fff' : 'var(--text-secondary, #5a6b7b)',
                                    border: on ? '1px solid transparent' : '1px solid rgba(15,31,46,0.14)',
                                    boxShadow: on ? '0 3px 10px rgba(13,161,178,0.30)' : 'none',
                                    transition: 'background .12s ease, color .12s ease',
                                    opacity: readOnly && !on ? 0.55 : 1,
                                }}
                            >
                                <i className={on ? 'fas fa-check' : 'far fa-user'} style={{ fontSize: 10 }}></i>
                                {u.name}{u.surname ? ' ' + u.surname : ''}
                            </button>
                        );
                    })}
                    {users.length === 0 && <span style={{ fontSize: 12, color: 'var(--text-muted, #8a99a8)' }}>No active users</span>}
                </div>
            </div>);
    };
}

const mapStateToProps = state => ({
    users: state.companies.company.users,
})

const mapDispatchToProps = {

}

export default connect(mapStateToProps, mapDispatchToProps)(UsersComponent)
